import { render } from "./Arb.vue?vue&type=template&id=6a424e58&scoped=true"
import script from "./Arb.vue?vue&type=script&lang=js"
export * from "./Arb.vue?vue&type=script&lang=js"

import "./Arb.vue?vue&type=style&index=0&id=6a424e58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a424e58"

export default script